module.exports = __webpack_public_path__ + "img/isle_of_man.4120a88.webp";